/* eslint-disable react/prop-types */
import { Box, Container } from '@mui/material';
import React from 'react';
import { Hero, MetricsSection, PipelineJourney } from './HeroSection';
import {
  AdvancedAIFeatures,
  BentoFeatures,
  FeaturesHero,
  HomeFeatureCards,
  SecurityBlock,
} from './FeaturesSection';
import { PricingGrid, FAQ } from './PricingSection';

// eslint-disable-next-line arrow-body-style
const LandingPage = ({ onStartFreeTrial, onNavigateToSection, onSelectPlan }) => {
  return (
    <>
      <Box id="home">
        <Hero onStartFreeTrial={onStartFreeTrial} onNavigateToSection={onNavigateToSection} />
        <MetricsSection />
        <PipelineJourney />
      </Box>

      <Box id="features">
        <FeaturesHero />
        <HomeFeatureCards />
        <BentoFeatures />
        <AdvancedAIFeatures />
        <SecurityBlock />
      </Box>

      <Box
        id="pricing"
        sx={{ pt: { xs: 4, md: 5 }, pb: { xs: 4, md: 5 }, bgcolor: 'background.default' }}
      >
        <Container maxWidth="lg">
          <PricingGrid onSelectPlan={onSelectPlan} />
        </Container>
      </Box>
      <FAQ />
    </>
  );
};

export default LandingPage;
